export function OutlinePauseIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.01945 3H7.01145C5.90865 3 5.01465 3.894 5.01465 4.9968V19.0032C5.01465 20.106 5.90865 21 7.01145 21H8.01945C9.12225 21 10.0162 20.106 10.0162 19.0032V4.9968C10.0162 3.894 9.12225 3 8.01945 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M17.0194 3H16.0114C14.9086 3 14.0146 3.894 14.0146 4.9968V19.0032C14.0146 20.106 14.9086 21 16.0114 21H17.0194C18.1223 21 19.0162 20.106 19.0162 19.0032V4.9968C19.0162 3.894 18.1223 3 17.0194 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
